import { resolveThreshold } from "../../selectors";
import type { DashboardWidget, ResolvedWidgetValue } from "../../types";
import { describeSignalDiagnostic } from "./diagnosticMeaning";
import type { HeroTone } from "./HeroCard";
import { effectiveQuality } from "./quality";

type ReadingMeaning = { tone: HeroTone; text: string; animated?: boolean };

/** Ausência não é violação de limite; diagnóstico só vale enquanto recente. */
export function describeReadingState(
  value: ResolvedWidgetValue,
  customUnavailable?: string,
): ReadingMeaning | null {
  const quality = effectiveQuality(value);
  if (quality === "live") {
    const diagnosed = describeSignalDiagnostic(value.diagnostic);
    if (diagnosed) return diagnosed;
    if (value.isAvailable) return null;
  }
  if (customUnavailable) return { tone: "muted", text: customUnavailable };
  switch (quality) {
    case "waiting": return { tone: "muted", text: "Aguardando telemetria", animated: true };
    case "stale": return { tone: "warn", text: "Sem leitura recente" };
    case "offline": return { tone: "muted", text: "Sem sinal · dispositivo offline" };
    default: return { tone: "muted", text: "Sem leitura" };
  }
}

/** Explica a regra configurada, inclusive zero e a igualdade no corte. */
export function describeThreshold(
  widget: DashboardWidget,
  value: ResolvedWidgetValue,
): ReadingMeaning | null {
  if (!value.isAvailable || effectiveQuality(value) !== "live") return null;
  const threshold = resolveThreshold(value.numericValue, widget.settings.thresholds);
  if (!threshold || (threshold.tone !== "warn" && threshold.tone !== "danger")) return null;
  const label = threshold.label?.trim() || (threshold.tone === "danger" ? "Limite crítico" : "Atenção ao limite");
  // Casas do valor atual não podem arredondar a regra (ex.: corte 0,92 e leitura com 0 casas).
  const at = threshold.at.toLocaleString("pt-BR", { maximumSignificantDigits: 21 });
  const unit = widget.settings.unit?.trim();
  return { tone: threshold.tone, text: `${label} · ${threshold.direction === "below" ? "≤" : "≥"} ${at}${unit ? ` ${unit}` : ""}` };
}
